export default __webpack_public_path__ + "static/media/wwdatabase.f28b90ac.mp4";